"use client";

import { useEffect, createContext, useState } from "react";
import { initAmplitude } from "@/services/Amplitude";
import { AmplitudeContextProviderProps, IAmplitudeContext } from "./types";

export const AmplitudeContext = createContext<IAmplitudeContext | undefined>(undefined);

export const AmplitudeContextProvider: React.FC<AmplitudeContextProviderProps> = ({ children }) => {
  const [source, setSource] = useState("");
  const [data, setData] = useState();

  useEffect(() => {
    initAmplitude();
  }, []);

  const value = {
    source,
    setSource,
    data,
    setData,
  };

  return <AmplitudeContext.Provider value={value}>{children}</AmplitudeContext.Provider>;
};
